import { render } from "./ViewSelector.vue?vue&type=template&id=0f7717dc"
import script from "./ViewSelector.vue?vue&type=script&lang=js"
export * from "./ViewSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/cube-viewer/cube-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__